import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';

import * as types from '../../../actionTypes';

/**
 * @typedef {{
 *  loading: {
 *    reorder: boolean,
 *    remove: string[],
 *    patch: boolean,
 *  },
 * }} StepUiDashboardReducer
 */

const LOADING_CONFIG = {
  global: {
    selectId: entity => entity?.data?.stepId ?? entity?.stepId ?? entity,
  },
};

export default combineReducers({
  loading: combineReducers({
    reorder: loading(types.REORDER_STEPS_REQUEST),
    patch: loading(types.PATCH_STEPS_MODE_REQUEST),
    remove: loadingArraySlice(types.DELETE_STEP_REQUEST, LOADING_CONFIG),
  }),
});
